import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    React.useEffect(() => { document.title = "404 — Lost in the meadow | Loomara"; }, []);
    return (
        <div className="container-boutique py-24 text-center" data-testid="not-found-page">
            <p className="eyebrow">404</p>
            <h1 className="font-serif text-6xl text-ink-900 mt-4 leading-none">Lost in the <span className="italic text-sage-600">meadow</span>.</h1>
            <p className="text-ink-500 mt-4">The page you're looking for is hiding among the daisies.</p>
            <Link to="/" className="btn-primary mt-8 inline-flex">Back to Loomara</Link>
        </div>
    );
}
